import { Axios } from '../api';
import { REGISTERS_API_URL } from '../constants';
import { type AppDatabase } from '../db';
import type { PaymentRestriction } from '../models/payment-restriction';
import type { PaymentRestrictionType } from '../types';

export class PaymentRestrictionService {
    constructor(private readonly db: AppDatabase) {
        this.db = db;
    }

    async fetchAndBulkUpsert() {
        const response = await Axios.get<PaymentRestriction[]>(
            REGISTERS_API_URL.REGISTER.PAYMENT_RESTRICTIONS,
        );

        await this.bulkUpsert(response.data);
    }

    async getByType(type: PaymentRestrictionType) {
        return this.db.paymentRestrictions.where('type').equals(type).first();
    }

    async getAll() {
        const restrictions = await this.db.paymentRestrictions.toArray();

        return restrictions;
    }

    private async bulkUpsert(paymentRestrictions: PaymentRestriction[]) {
        await this.db.paymentRestrictions.clear();
        await this.db.paymentRestrictions.bulkPut(paymentRestrictions);
    }
}
